"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var styles = require('./OptionsFull.scss');
var OptionsForm = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsForm, _super);
    function OptionsForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptionsForm.prototype.render = function () {
        var option = this.props.option;
        var fullOptionFormSettings = option.fullOptionFormSettings, key = option.key;
        if (!fullOptionFormSettings) {
            return null;
        }
        var optionAriaId = "options-full-" + key;
        return (React.createElement("div", { className: styles.optionEntry },
            React.createElement("div", { className: styles.header, role: "heading", "aria-level": 4 },
                React.createElement("span", { className: styles.title, id: optionAriaId }, owa_options_strings_1.default[this.props.option.titleStringKey])),
            React.createElement("div", { className: styles.formContainer, "aria-labelledby": optionAriaId }, fullOptionFormSettings.render())));
    };
    OptionsForm = tslib_1.__decorate([
        mobx_react_1.observer
    ], OptionsForm);
    return OptionsForm;
}(React.Component));
exports.default = OptionsForm;
//# sourceMappingURL=OptionsForm.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/components/full/OptionsForm.js
// module id = 5303
// module chunks = 2